<template>
  <div>
    <Spin 
      v-bind="$attrs"
      v-on="$listeners"
      :class="[opaque ? 'opaque-loader' : '']"
    >
      <slot />
    </Spin>
  </div>
</template>

<script>
import { Spin } from "ant-design-vue";
export default {
  props: {
    opaque: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Spin
  }
};
</script>

<style lang="sass" scoped>
.opaque-loader
  /deep/
    .ant-spin-blur
      opacity: 0 !important
    .ant-spin-dot-spin
      height: 2rem !important
      width: 2rem !important
</style>
